import FollowUpRule from './FollowUpRule';
import RenderMode from './RenderMode';
import SurveyChoiceOption from './SurveyChoiceOption';
import SurveyQuestion from './SurveyQuestion';
import SurveyQuestionType from './SurveyQuestionType';

class SurveyQuestionIntroduction extends SurveyQuestion {
  options: SurveyChoiceOption[];

  allowMultiSelect: boolean;

  renderMode: RenderMode;

  introPrefix: string;

  introTitle: string;

  constructor(
    questionId: string,
    questionType: SurveyQuestionType,
    title: string,
    description: string,
    group: string,
    variability: string,
    identifier: string,
    options: SurveyChoiceOption[],
    allowMultiSelect: boolean,
    renderMode: RenderMode,
    introPrefix: string,
    introTitle: string,
    followUpRules: FollowUpRule[],
    imageIdentifier: string,
    info?: string,
    suffix?: string,
    allowSkipWithDefaultValue?: boolean
  ) {
    super(
      questionId,
      questionType,
      title,
      description,
      group,
      variability,
      identifier,
      followUpRules,
      imageIdentifier,
      info,
      suffix,
      allowSkipWithDefaultValue
    );

    this.options = options;
    this.allowMultiSelect = allowMultiSelect;
    this.renderMode = renderMode;
    this.introPrefix = introPrefix;
    this.introTitle = introTitle;
  }

  public static parse(object: any) {
    return new SurveyQuestionIntroduction(
      object.QuestionId,
      object.QuestionType,
      object.Title,
      object.Description,
      object.Group,
      object.Variability,
      object.Identifier,
      object.Options.map((option: {}) => SurveyChoiceOption.parse(option)),
      object.AllowMultiSelect,
      object.RenderMode,
      object.IntroPrefix,
      object.IntroTitle,
      object.FollowUpRules.map((rule: {}) => FollowUpRule.parse(rule)) ?? [],
      object.ImageIdentifier,
      object.Info || undefined,
      object.Suffix ?? undefined,
      object.AllowSkipWithDefaultValue ?? undefined
    );
  }
}

export default SurveyQuestionIntroduction;
